import { render, staticRenderFns } from "./xxgk.vue?vue&type=template&id=00d56246&scoped=true&"
import script from "./xxgk.vue?vue&type=script&lang=js&"
export * from "./xxgk.vue?vue&type=script&lang=js&"
import style0 from "./xxgk.vue?vue&type=style&index=0&id=00d56246&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d56246",
  null
  
)

export default component.exports